import { PqlPrice } from 'types/PqlPrice';

export const retrievePqlPrice = (pqlPrices: PqlPrice[], mspn: string, tireMspn: string) => {
  const founded = pqlPrices.find((p) => p.mspn === mspn && p.tireMspn === tireMspn);
  if (founded !== undefined) return founded.price;

  return null;
};
